export const en = {
    'ad-decline-req': 'Ads were rejected for not complying with placement rules.',
    'how-to-fix': 'Learn how to fix your ad in the Status column.',
    'many-banner-title': 'Change {count} ads so they pass moderation',
    'one-banner-title': 'Change {count} ad so it passes moderation',
    'one-banner-title-hint': 'The recommendation is shown because the ad did not pass moderation',
    'open-ad-list': 'To find out why your ads were rejected and correct them, please check your ad design and content.',
    'popup-ad-decline-req': 'The ad was rejected for not complying with placement rules.',
    'several-banner-title-hint': 'This recommendation is shown because some ads did not pass moderation',
    'show-many-banner-button': 'View {count} ads',
    'show-one-banner-button': 'View {count} ad',
    'show-some-banner-button': 'View {count} ads',
    'simple-title': 'Change an ad so it passes moderation',
    'some-banner-title': 'Change {count} ads so they pass moderation',
    'twenty-one-banner-title': 'Change {count} ads so they pass moderation'
};
